import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import { UserSelectionDesign } from "@/enums/BuilderUserSelectionDesign";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import Ellipse from "@/components/builder/Ellipse.vue";
  import BuilderOpenMessageReviewQuote from "@/components/builder/BuilderOpenMessageReviewQuote.vue";
  import { BuilderMessageType } from "@/enums/BuilderMessageType";
  interface Props {
    selections: UserSelectionDesign;
    houseName: string;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'HouseSelectionsCard',
  props: {
    selections: {},
    houseName: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const isDesignModification = ref(false);
  const fadeInEffect = ref(false);

  const openDesignModification = () => {
    isDesignModification.value = !isDesignModification.value;

    setTimeout(() => {
      fadeInEffect.value = !fadeInEffect.value;
    }, 50);
  };

const __returned__ = { props, isDesignModification, fadeInEffect, openDesignModification, ref, get UserSelectionDesign() { return UserSelectionDesign }, get HouseDesignInterface() { return HouseDesignInterface }, Ellipse, BuilderOpenMessageReviewQuote, get BuilderMessageType() { return BuilderMessageType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})